var _rect, _rect2, _rect3, _g, _rect4, _circle, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIPhoneBig({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 2.5,
    width: 39,
    height: 75,
    rx: 7.5,
    fill: "#10141A",
    stroke: "url(#phone_outer)",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.75,
    y: 4.75,
    width: 34.5,
    height: 70.5,
    rx: 5.25,
    stroke: "url(#phone_inner)",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 10,
    width: 30,
    height: 59,
    rx: 3.5,
    fill: "#0B0F14"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#43B96B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.15 19.15C30.55 20.8 31.2 21.45 32.85 21.85",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#3E8BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2 19.1H41.8V21.35H39.55L38.45 22V21.35H38.2V19.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 17,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#8A6CF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.35,
    y: 19,
    width: 4.3,
    height: 3.2,
    rx: 0.75,
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 20.6,
    r: 0.75,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 28,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#F15B64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6 30.35H33.4M30.2 29.45V31.05M32.8 29.45V31.05",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.55,
    y: 29.7,
    width: 3.9,
    height: 3.65,
    rx: 0.65,
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 28,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#F2A93B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.05 30.25L40 31.75L41.95 30.25",
    stroke: "white",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.9,
    y: 30,
    width: 4.2,
    height: 3.1,
    rx: 0.65,
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 28,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#28B8C8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 31.5,
    r: 1.8,
    stroke: "white",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 29.7V33.3M46.7 31.5H50.3",
    stroke: "white",
    strokeWidth: 0.55,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 39,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#4DA3FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 42.5,
    r: 1.1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3 44.15L30.65 42.9L31.45 43.55L32.45 42.45L33.7 44.15",
    stroke: "white",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 39,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#69727E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42.5,
    r: 1.55,
    stroke: "white",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 42.5,
    r: 0.55,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 40.35V40.8M40 44.2V44.65M37.85 42.5H38.3M41.7 42.5H42.15",
    stroke: "white",
    strokeWidth: 0.55,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 39,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#EC668D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.8 42.35C47.25 41.45 49.75 41.45 50.2 42.35C50.55 43.1 49.45 43.85 48.5 44.35C47.55 43.85 46.45 43.1 46.8 42.35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 50,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#6D7AEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 51.65V55.35M29.65 53.5H33.35",
    stroke: "white",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 50,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#36B681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.15 53.55L39.35 54.65L41.9 52.25",
    stroke: "white",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 50,
    width: 7,
    height: 7,
    rx: 1.8,
    fill: "#59636F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 53.5,
    r: 1.6,
    stroke: "white",
    strokeWidth: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5 52.55V53.55L49.2 54",
    stroke: "white",
    strokeWidth: 0.55,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.5,
    cy: 62.5,
    r: 0.55,
    fill: "#59616B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 62.5,
    r: 0.55,
    fill: "#323944"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 6.5,
    width: 10,
    height: 1.5,
    rx: 0.75,
    fill: "#6E737A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 7.25,
    r: 0.8,
    fill: "#62676E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 72,
    width: 7,
    height: 1.25,
    rx: 0.625,
    fill: "#676C73"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_outer",
    x1: 24,
    y1: 7,
    x2: 58,
    y2: 73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#50545A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82868C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "phone_inner",
    x1: 28,
    y1: 9,
    x2: 53,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4E5359"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#262B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5C6168"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIPhoneBig);
export default __webpack_public_path__ + "static/media/i_phone_big.f2f7ed3d23e332f260222184044d20dd.svg";
export { ForwardRef as ReactComponent };